module.exports = __webpack_public_path__ + "img/013.562c6f69.png";